<template>
    <div class="card">
        <DadosPrestador :resumo="resumo" />
        <InfoAtendimento :protocolo="dadosAtendimento.protocolo" :dataAtendimento="dadosAtendimento.dataAtendimento"
            :horaAtendimento="dadosAtendimento.horaAtendimento" :dataAgendamento="dadosAtendimento.dataAgendamento"
            :horaAgendamento="dadosAtendimento.horaAgendamento" :nomeServico="dadosAtendimento.nomeServico" />
        <hr />
        <InfoProprietario :nomeProprietario="dadosAtendimento.nomeSolicitante" :placa="dadosAtendimento.placa"
            :modelo="dadosAtendimento.modelo" :cor="dadosAtendimento.corVeiculo"
            :telefoneSolicitante="dadosAtendimento.telefoneSolicitante" />
        <hr />
        <Rota :enderecoOrigem="dadosAtendimento.enderecoOrigem" :enderecoDestino="dadosAtendimento.enderecoDestino" />
    </div>
</template>

<script>
import { defineComponent } from 'vue';

import InfoAtendimento from '@/common/dadosAtendimento/components/InfoAtendimento.vue';
import InfoProprietario from '@/common/dadosAtendimento/components/InfoProprietario.vue';
import Rota from '@/common/dadosAtendimento/components/Rota.vue';
import DadosPrestador from '@/common/dadosAtendimento/components/DadosPrestador.vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import ComponenteDadosAtendimentoService from '@/services/componentes/ComponenteDadosAtendimentoService';

export default defineComponent({
    name: 'DadosAtendimento',
    components: {
        InfoAtendimento,
        InfoProprietario,
        Rota,
        DadosPrestador
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    setup() {
        return ComponenteDadosAtendimentoService.setup();
    }
});
</script>